// Local storage service for Tamagotchi persistence and time-warp simulation

const STORAGE_KEY = 'happy_pet_state_v1';

export const storage = {
  get() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.error('Failed to load game state from localStorage', e);
      return null;
    }
  },

  set(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      console.error('Failed to save game state to localStorage', e);
    }
  },

  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error('Failed to clear game state', e);
    }
  }
};
